

































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import api from "@/api";
import uploadNew from "@/components/uploadNew.vue";
import {clientLink, showTagRE} from '@/utils/common'

@Component({
    name: "activityAdd",
    components: {
        uploadNew: uploadNew
    }
})

export default class extends Vue {

    canyuProduct: any = ''


    // 可用机构
    showIconOrg = true
    orgList: any = []
    orgListC: any = []
    orgDialog = false
    orgData: any = []
    keyword = ''
    getOrg() {
        this.orgData = []
        api
            .post('J27716', {keyword: this.keyword, status: 1})
            .then(res => {
                this.orgDialog = true
                this.orgData = res.list
            })
    }

    handleOrgChange(val: any) {
        this.orgList = val
    }

    sureOrg() {
        if(this.orgList.length != 0) {
            this.showIconOrg = false
            this.orgListC = [...this.orgList]
        }
        this.orgDialog = false
    }

    closeOrgDialog() {
        this.orgDialog = false
    }

    delTag(row: any) {
        this.orgListC.splice(this.orgListC.findIndex((item: any) => item.code === row.code), 1)
        // this.orgListC = [...this.orgList]
        if(this.orgListC.length == 0) {
            this.showIconOrg = true
        }
    }
    delAll() {
        // this.orgList = []
        this.orgListC = []
        this.showIconOrg = true;
        (this.$refs.table as any).clearSelection();
    }
    editOrgList() {
        this.orgList = [...this.orgListC]
        this.orgDialog = true
    }
    open() {
        api.post('J27716', {keyword: this.keyword, status: 1})
            .then(res => {
                this.orgData = res.list
        

                let selected = this.orgListC;//默认要选择复选框的数据
                // (this.$refs as any).table2.clearSelection();
                (this.$refs.table as any).clearSelection();
                selected.forEach((item:any) => { // checkedData为已选数据
                    this.$nextTick( ()=>{
                        this.orgData.find((obj: any) => { // userData 表单数据
                            if(item.id == obj.id) {
                                (this.$refs.table as any).toggleRowSelection(obj,true);
                                // this.$forceUpdate()
                            }
                        })

                    })
                })
            })

    }

    form: any = {

    }

    // 标签
    tagVal = ''
    tags: any = []
    tagsC: any = []
    newTags: any = []
    delTags: any = []


    handleClose(tag: any) {
        this.delTags.push(tag)
        this.tags.splice(this.tags.indexOf(tag), 1);

    }


    sureLoading = false
    sure() {
        if(!this.form.activityName){
            this.$message.warning('请填写活动名称')
            return
        }
        if(!this.form.activityStartTime){
            this.$message.warning('请填写活动开始时间')
            return
        }
        if(!this.form.activityEndTime){
            this.$message.warning('请填写活动结束时间')
            return
        }
        // 验证活动结束时间不能早于活动开始时间
        if(new Date(this.form.activityEndTime) < new Date(this.form.activityStartTime)){
            this.$message.warning('活动结束时间不能早于活动开始时间')
            return
        }
        if(this.form.participateType === '') {
            this.$message.warning('请填写抽奖次数')
            return
        }
        if(this.form.giveType === '') {
            this.$message.warning('请选择赠送积分类型')
            return
        }
        if(!this.form.giveQuantity) {
            this.$message.warning('请填写赠送积分数量')
            return
        }
        if(!this.canyuProduct) {
            this.$message.warning('请选择参与商品')
            return
        }
        if(this.canyuProduct == 2) {
            if(this.orgListC.length == 0) {
                this.$message.warning('请选择参与商品')
                return
            }
        }
        

        if(this.canyuProduct == 1) {
            this.form.participateProducts = '00000'
        } else if(this.canyuProduct == 2) {
            let a: any = []
            this.orgListC.forEach((item: any) => {
                a.push(item.id)
            })
            
            this.form.participateProducts = a.join('@')
        }
        



        this.sureLoading = true
        api
            .post(this.id ? 'J27748' : 'J27745', this.form)
            .then(res =>{
                this.tags = []
                this.newTags = []
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
        
                this.$router.push({
                    name: 'applet_activity_point'
                })
            }).finally(() => {
                this.sureLoading = false
        })

    }

    cancle() {
        this.$router.back()
    }


    // 编辑
    getDetail(id: any) {
        api
            .post('J27747', {id: this.id})
            .then(async (res: any) => {
                this.form = res

                

                if(this.form.participateProducts) {
                
                    if(this.form.participateProducts == '0000' || this.form.participateProducts == '00000') {
                        this.canyuProduct = '1'
                        return
                    }
                    this.canyuProduct = '2'
                    let a: any = []
                    let sendingOrganizationCode = this.form.participateProducts.split('@')
               
                    api
                        .post('J27716', this.keyword)
                        .then(res => {
                            this.orgData = res.list
                  
                            this.orgData.forEach((row: any) => {

                                sendingOrganizationCode.forEach((item: any) => {
                                    if(row.id == item) {
                                        a.push(row)
                                    }
                                })
                            })
                            this.orgListC = a
                            this.showIconOrg = false
                        })
                }



            })
    }

    config = {}
    getConfig() {
        api.getJavaConfig().then((res) => {
        this.config = res;
        });
    }


    id: any = ''
    showUpload = true
    activated() {
        this.form = {}

        this.showIconOrg = true
        this.orgListC = []
        this.id = this.$route.query.id

        this.getConfig()
        if(this.id) {
            this.getDetail(this.id)

        }
        this.showUpload = false
        this.$nextTick(() => {this.showUpload = true})

    }


}
